import { environment } from '@environment';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { contextReducer } from './context/context.reducer';
import { IContextState } from './context/context.state';

export interface IHotelsAppState {
  context: IContextState;
  router: RouterReducerState;
}

export const reducers: ActionReducerMap<IHotelsAppState> = {
  context: contextReducer,
  router: routerReducer,
};

export function storeLogger(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<IHotelsAppState>[] = !environment.production
  ? [storeLogger]
  : [];
